import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Translate from '../Translate';
import FilterSelectBox from '../formComponents/FilterSelectBox';
import translator from '../../translations/drupalTranslator';
import FocusableTrigger from '../FocusableTrigger';
import CheckboxInput from '../formComponents/CheckboxInput';
import Tooltip from '../Tooltip';

/* eslint-disable react/no-set-state */
class BookingOverviewGuests extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.order.adults === 0,
    };
    this.toggleGuestsInputs = this.toggleGuestsInputs.bind(this);
  }

  toggleGuestsInputs(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({open: !this.state.open});
  }

  render() {
    const { props } = this;

    const inputOnChange = (name, value) => props.updateGuests(name,
      value);
    const freeChildrenOnChange = (name, value) => props.updateAdditionalChildren(value);
    const createSelectOptionsFromValue = value => ({text: value, value});

    let guestsClass = 'booking-overview__guests';

    if (this.state.open) {
      guestsClass += ' booking-overview__guests--expanded';
    }

    let petsSelectBox;
    let petsInfo;

    if (props.rental.information.allowedPetCount > 0) {
      let petsPrice = props.rental.information.petsPrice;
      petsSelectBox = (
        <div>
          <label
            htmlFor="booking-overview-select-pets"
          >
            {translator.translate('Pets')}
            {petsPrice && (
              <>
                <span className="booking-overview-select-children-separator"> </span>
                <span>(+{petsPrice})</span>
              </>
            )}
          </label>
          <FilterSelectBox
            clearable={false}
            id="booking-overview-select-pets"
            name="pets"
            onChange={inputOnChange}
            options={props.availablePets.map(createSelectOptionsFromValue)}
            placeholder={props.order.pets}
            searchable={false}
            value={props.order.pets}
          />
        </div>
      );

      petsInfo = (
        <span className="booking-overview__pets">
          <i />
          {' '}
          {props.order.pets}
        </span>
      );
      guestsClass += ' is-pets-input-available';
    }

    const adultSelectClass = cx({
      'Select--error': parseInt(props.order.adults, 10) === 0,
    });

    const childrenFreeOfCharge = parseInt(props.rental.information.kidsFreeOfCharge,
      10);
    const termsArgs = {
      '!children_count': childrenFreeOfCharge.toString(),
    };

    return (
      <div className={guestsClass}>
        <div>
          <div className="booking-overview__guests-wrapper">
            <FocusableTrigger
              className="booking-overview__guests-trigger"
              onClick={this.toggleGuestsInputs}
            >
              <Translate content="Guests" />
            </FocusableTrigger>

            <div
              className="booking-overview__guests-list"
              onClick={this.toggleGuestsInputs}
              onKeyPress={this.toggleGuestsInputs}
              role='button'
              tabIndex='0'
            >
              <span className="booking-overview__adults">
                <i />
                {' '}
                {props.order.adults}
              </span>
              <span className="booking-overview__children">
                <i />
                {' '}
                {props.order.children}
                {props.order.childrenFreeOfCharge ? '+' : null}
              </span>
              {petsInfo}
            </div>
          </div>
        </div>

        <div className="guests-widget">
          <div className="guests-widget__inputs">
            <div>
              <label
                htmlFor="booking-overview-select-adults"
              >
                {translator.translate('Adults')}
              </label>
              <FilterSelectBox
                className={adultSelectClass}
                clearable={false}
                id="booking-overview-select-adults"
                name="adults"
                onChange={inputOnChange}
                options={props.availableAdults.map(createSelectOptionsFromValue)}
                placeholder={props.order.adults}
                searchable={false}
                value={props.order.adults}
              />
            </div>

            <div>
              <label
                htmlFor="booking-overview-select-children"
              >
                {translator.translate('Children')}
                <span className="booking-overview-select-children-separator"> </span>
                <span className="dansommer-only">
                  {translator.translate('(4-11 years)')}
                </span>
                <span className="novasol-only">
                  {translator.translate('(0-11 years)')}
                </span>
                <span className="cuendet-only">
                  {translator.translate('(0-11 years)')}
                </span>
              </label>
              <FilterSelectBox
                clearable={false}
                id="booking-overview-select-children"
                name="children"
                onChange={inputOnChange}
                options={props.availableChildren.map(createSelectOptionsFromValue)}
                placeholder={props.order.children}
                searchable={false}
                value={props.order.children}
              />
            </div>

            {petsSelectBox}
          </div>

          {childrenFreeOfCharge > 0 && (
            <div className="guests-widget__children-free-of-charge">
              <CheckboxInput
                name="childrenFreeOfCharge"
                onChange={freeChildrenOnChange}
                value={props.order.childrenFreeOfCharge}
              />
              <label htmlFor="childrenFreeOfCharge">
                {childrenFreeOfCharge === 1 &&
                  <Translate content="Plus an additional child below 4 years." />
                }
                {childrenFreeOfCharge > 1 && (
                  <Translate
                    args={termsArgs}
                    content="Plus I bring up to !children_count children below 4 years"
                  />
                )}
              </label>
              <Tooltip>
                <Translate content="In this holiday home you can bring a child (or children) FREE of charge. Please tick this box, if you would like to take advantage of the offer" />
              </Tooltip>
            </div>
          )}

          <div className="guests-widget__actions">
            <FocusableTrigger
              className="guests-widget__confirm awaze-nonlink"
              onClick={this.toggleGuestsInputs}
            >
              {translator.translate('Confirm')}
            </FocusableTrigger>
          </div>
        </div>
      </div>
    );
  }
}

BookingOverviewGuests.PropTypes = {
  availableAdults: PropTypes.shape({}).isRequired,
  availableChildren: PropTypes.shape({}).isRequired,
  availablePets: PropTypes.shape({}).isRequired,
  petsPrice: PropTypes.string.isRequired,
  errors: PropTypes.shape([]).isRequired,
  order: PropTypes.shape([]).isRequired,
  rental: PropTypes.shape([]).isRequired,
  updateAdditionalChildren: PropTypes.func.isRequired,
  updateGuests: PropTypes.func.isRequired,
};

export default BookingOverviewGuests;
